<template>
  <div v-if="state.profile" class="gmf-profile-skin-selector gmf-context" :class="darkSkinClass">
    <div v-if="selectSkin" :style="computedSkinStyle" class="gmf-profile-skin-selector-skin"></div>
    <Avatar disablePopup :customer="state.profile" disablePopout disableOnlineIndicator view="fullbody" :lazy="false" />
    <div class="gmf-profile-skin-selector-container gmf-scrollbar">
      <h3 class="gmf-subheader">Välj Bakgrund</h3>
      <ItemGrid :items="availableSkins" :selectedItems="[selectedSkin]" :showNames="false" @select="(item) => selectSkin(item)"></ItemGrid>
    </div>
    <div class="gmf-profile-skin-selector-footer">
      <button class="gmf-btn gmf-btn-primary" :class="{ 'gmf-invisible': ! hasChanges }" @click="save" :disabled="! hasChanges">{{ t('customer_attributes_editor.save') }}</button>
    </div>
  </div>
</template>

<style>
.gmf-modal-body:has(.gmf-profile-skin-selector) {
  padding: 0;
}

.gmf-profile-skin-selector {
  width: 400px;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 90vh;
  max-height: 600px;
  border-radius: var(--gmf-modal-rounding);
  position: relative;
}

.gmf-profile-skin-selector.gmf-dark {
  background: black;
}

.gmf-profile-skin-selector-container > .gmf-subheader {
  position: sticky;
  top: 0;
  width: calc(100% + var(--gmf-p-4) * 2);
  z-index: 2;
  background: var(--gmf-col-white);
  margin-left: calc(var(--gmf-p-4) * -1);
  padding: var(--gmf-p-3) var(--gmf-p-4);
}

.gmf-profile-skin-selector-skin {
  position: absolute;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: var(--gmf-modal-rounding);
  height: 400px;
  width: 100%;
}

.gmf-profile-skin-selector .gmf-avatar-content  {
  -webkit-user-drag: none;
  user-select: none;
  border-radius: 0;
  width: auto;
  margin: auto;
}

.gmf-profile-skin-selector .gmf-avatar {
  background: none;
  height: 350px;  
  transform: translateX(-50%);
  position: absolute;
  top: -30px;
  left: 50%;
}

.gmf-profile-skin-selector-container {
  background: var(--gmf-col-white);
  padding-inline: var(--gmf-p-4);
  margin-top: 180px;
  overflow-y: scroll;
  overflow-x: hidden;
  flex-grow: 1;
  z-index: 1;
}
.gmf-profile-skin-selector-container .gmf-item-grid {
  margin-top: 0;
}
.gmf-profile-skin-selector-container .gmf-item-content {
  padding: 0;
}
.gmf-profile-skin-selector-footer {
  text-align: center;
  position: absolute;
  bottom: var(--gmf-p-1);
  pointer-events: none;
  z-index: 999;
  width: calc(100% - var(--gmf-p-3) * 2);
  margin: var(--gmf-p-3);
}
.gmf-profile-skin-selector-footer .gmf-btn {
  margin: auto;
  pointer-events: all;
}
.gmf-profile-skin-selector-footer .gmf-btn.gmf-invisible {
  pointer-events: none;
}
</style>

<script>
import state from '@/state';
import callApi from '@/utils/callApi';

import Avatar from '@/components/Avatar';
import ItemGrid from '@/components/Items/ItemGrid';

export default {
  name: 'ProfileSkinSelector',
  components: {
    Avatar,
    ItemGrid,
  },
  data() {
    return {
      state,
      availableSkins: [],
      savedSkin: state.profile?.profileSkin,
      selectedSkin: state.profile?.profileSkin,
      publicProfile: state.profile?.publicProfile,
    };
  },
  inject: [ 'closeModal' ],
  computed: {
    hasChanges() {
      if (this.publicProfile !== state.profile.publicProfile) {
        return true;
      }
      if (this.selectedSkin.uuid !== this.savedSkin.uuid) {
        return true;
      }
      return false;
    },
    darkSkinClass() {
      return { 'gmf-dark': this.selectedSkin?.dark };
    },
    computedSkinStyle() {
      return {
        backgroundImage: 'url('+(this.selectedSkin?.imageUrl || this.selectedSkin?.image_url)+')',
        opacity: this.selectedSkin?.opacity, 
      };
    },
  },
  methods: {
    async save() {
      if (this.selectedSkin) {
        await callApi('POST', '/v1/client/my-customer-profile-skins/' + this.selectedSkin.uuid);
        this.savedSkin = this.selectedSkin;
        state.profile.profileSkin = this.selectedSkin;
      }
      this.closeModal();
    },
    async loadSkins() {
      const res = await callApi('GET', '/v1/client/my-customer-profile-skins');
      const json = await res.json();
      this.availableSkins = json.availableSkins;
      for (const skin of this.availableSkins) {
        skin.type = 'profile-skin';
        skin.url = skin.imageUrl || skin.image_url;
      }
    },
    selectSkin(skin) {
      this.selectedSkin = skin;
    },
    t: state.t,
  },
  mounted() {
    if (!state.profile) {
      return;
    }
    this.loadSkins();
  },
  watch: {
    'state.profile': function (to, frm) {
      if (to && !frm) {
        this.loadSkins();
        this.savedSkin = state.profile?.profileSkin;
        this.selectedSkin = state.profile?.profileSkin;
        this.publicProfile = state.profile?.publicProfile;
      }
    },
  }
};
</script>
